function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 14.4A6.4 6.4 0 108 1.6a6.4 6.4 0 000 12.8zM8 0a8 8 0 110 16c-4.424 0-8-3.6-8-8a8 8 0 018-8zm.4 4v4.2l3.6 2.136-.6.984L7.2 8.8V4h1.2z",
  fill: "#A1B3CE"
});

function SvgTimeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/time-icon.60e9937b.svg";
export { SvgTimeIcon as ReactComponent };